export * from './lib/app-base-component';
export * from './lib/shared-app-base.module';
